import { useArgSelector } from '@/redux/curriedSelectors/curriedSelectors';
import { getActiveTitle } from '@/redux/selectors/titleSelectors';
import routes from '@/routes';
import { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

const TitleHandler = () => {
  const activeRouteId = useSelector((state) => state.ui.activeRouteId);
  const activeRouteGroupName = useMemo(() => routes.find((route) => route.id === activeRouteId)?.routeId, [activeRouteId]);
  const documentTitle = useArgSelector(getActiveTitle, activeRouteGroupName);

  useEffect(() => {
    if (document.title !== documentTitle) {
      document.title = documentTitle;
    }
  }, [documentTitle]);

  return null;
};

export default TitleHandler;
